<template>
  <SettingsPageLayout>
    <div class="max-w-5xl m-auto mb-12">
      <router-link :to="{ name: 'CandidateWorkflow' }" class="inline-block mb-8">
        <TButton color="white">Back</TButton>
      </router-link>

      <div v-if="showWorkflowDetails">
        <div class="flex flex-col gap-4 mb-6">
          <TitleBar />
          <ConditionsCard :editor="makeFilterEditor()" />
          <ActionsCard />
          <ConditionsCard v-if="hasScheduledActions" :editor="makeExitCriteriaEditor()" />
        </div>
        <div class="flex justify-end">
          <Button class="w-[min-content]" variant="destructive" @click="displayDeleteModal">Delete</Button>
        </div>
      </div>

      <div v-if="showLoading" class="spinner"></div>
    </div>
  </SettingsPageLayout>
  <Modal
    v-if="showDeleteModal"
    :title="deleteModal.title"
    :body="deleteModal.description"
    action="Delete"
    action-color="red"
    @close-modal="hideDeleteModal"
    @handle-action="deleteWorkflow"
  />
</template>

<script setup lang="ts">
import SettingsPageLayout from '@/components/layouts/SettingsPageLayout/index.vue';
import TitleBar from './title/TitleBar.vue';
import ConditionsCard from './conditions/ConditionsCard.vue';
import { Button } from '@/components/ui/button';
import Modal from '@/components/shared/Modal.vue';
import { useWorkflowDetail } from './useWorkflowDetail';
import ActionsCard from './actions/ActionsCard.vue';
import { useWorkflowConditionEditorProvider } from './conditions/useWorkflowConditionEditorProvider';

const { makeFilterEditor, makeExitCriteriaEditor } = useWorkflowConditionEditorProvider();

const {
  showLoading,
  showWorkflowDetails,
  showDeleteModal,
  hasScheduledActions,
  deleteModal,
  hideDeleteModal,
  displayDeleteModal,
  deleteWorkflow,
} = useWorkflowDetail();
</script>
